module.exports = __webpack_public_path__ + "img/AFMS_DRIGHT_OPEN.3bf33962.png";